import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { COMPANY, waLink } from "@/lib/constants";
import ContactForm from "@/components/ContactForm";

export default function ContactSection() {
    return (
        <section id="contact" className="py-20 lg:py-28 bg-slate-50" data-testid="contact-section">
            <div className="container-lg">
                <div className="max-w-2xl mb-12">
                    <span className="text-xs font-bold tracking-[0.24em] uppercase text-brand">Contact</span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy">
                        Let&apos;s design your next network.
                    </h2>
                    <p className="mt-4 text-slate-600">
                        Reach out for a site survey, a detailed quotation or a technical consultation —
                        we typically respond within one working hour.
                    </p>
                </div>

                <div className="grid lg:grid-cols-12 gap-6">
                    <div className="lg:col-span-5 space-y-4">
                        <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="contact-info-card">
                            <div className="grid grid-cols-1 gap-5">
                                <div className="flex items-start gap-3">
                                    <div className="w-10 h-10 rounded-lg bg-brand-soft text-brand flex items-center justify-center shrink-0">
                                        <MapPin className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <div className="text-xs uppercase tracking-wider font-bold text-slate-500">Office</div>
                                        <div className="text-sm text-navy mt-1 leading-relaxed">
                                            {COMPANY.address.line1}, {COMPANY.address.line2},<br />
                                            {COMPANY.address.city}, {COMPANY.address.state} {COMPANY.address.zip}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-start gap-3">
                                    <div className="w-10 h-10 rounded-lg bg-brand-soft text-brand flex items-center justify-center shrink-0">
                                        <Phone className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <div className="text-xs uppercase tracking-wider font-bold text-slate-500">Phone</div>
                                        <a href={`tel:${COMPANY.phoneRaw}`} className="text-sm text-navy mt-1 hover:text-brand font-semibold" data-testid="contact-phone">
                                            {COMPANY.phone}
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-start gap-3">
                                    <div className="w-10 h-10 rounded-lg bg-brand-soft text-brand flex items-center justify-center shrink-0">
                                        <Mail className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <div className="text-xs uppercase tracking-wider font-bold text-slate-500">Email</div>
                                        <a href={`mailto:${COMPANY.email}`} className="text-sm text-navy mt-1 hover:text-brand font-semibold" data-testid="contact-email">
                                            {COMPANY.email}
                                        </a>
                                    </div>
                                </div>
                                <div className="flex items-start gap-3">
                                    <div className="w-10 h-10 rounded-lg bg-brand-soft text-brand flex items-center justify-center shrink-0">
                                        <Clock className="w-5 h-5" />
                                    </div>
                                    <div>
                                        <div className="text-xs uppercase tracking-wider font-bold text-slate-500">Business Hours</div>
                                        <div className="text-sm text-navy mt-1">{COMPANY.hours}</div>
                                    </div>
                                </div>
                            </div>
                            <a
                                href={waLink()}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="contact-whatsapp-cta"
                                className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5A] text-white px-5 py-3 text-sm font-semibold transition-colors"
                            >
                                <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
                            </a>
                        </div>

                        <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
                            <iframe
                                title="CoreCyrus Location"
                                src="https://www.google.com/maps?q=Srinivasaa+Spaces,+Kandasamy+Layout,+Pappanaickenpalayam,+Coimbatore,+Tamil+Nadu+641037&output=embed"
                                width="100%"
                                height="280"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                data-testid="contact-map"
                                className="w-full block"
                            />
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </section>
    );
}
